import React from 'react';

import {css} from 'emotion';
import PropTypes from 'prop-types';

import {
  CREATED_BY_YOU_TAB_ITEM,
  SAVED_BY_YOU_TAB_ITEM,
  YOUR_SCHOOL_TAB_ITEM
} from 'static/three-oh/src/routes/YourContent/constants';

import NavMenuList from '../../NavMenuList';
import NavMenuListItem from '../../NavMenuList/NavMenuListItem';
import {AnchorWithTrackEvent} from '../GlobalNav';
import {
  listItemLinkStyle,
  ulPaddingOverride
} from './style';
import {activePageCheck} from './utils';

const propTypes = {
  history: PropTypes.object,
  userProperties: PropTypes.object
};

export const YourContentDrawer = (props) => {
  const {
    history,
    userProperties
  } = props;

  const activeURL = `${history.location.pathname}${history.location.search}`;

  return (
    <NavMenuList additionalClassName={css(ulPaddingOverride)}>
      <NavMenuListItem
        key={SAVED_BY_YOU_TAB_ITEM.name}
        /**
         * Navigation from the nav drawer was adding a forward slash to the url.
         * Navigating the Your Content page using the tabs does not add the forward slash.
         * Checking the url string starting at the 'tab=' parameter so that
         * this functionality works with both ways of navigating.
         */
        isHighlighted={activePageCheck(`tab=${SAVED_BY_YOU_TAB_ITEM.slug}`, activeURL)}
      >
        <AnchorWithTrackEvent
          aria-current={activePageCheck(`tab=${SAVED_BY_YOU_TAB_ITEM.slug}`, activeURL) ? 'page' : null}
          className={css(listItemLinkStyle)}
          eventName={`${SAVED_BY_YOU_TAB_ITEM.name}-Navigate`}
          eventProperties={{
            description: `your content drawer ${SAVED_BY_YOU_TAB_ITEM.name} link`
          }}
          href={`/my-content?tab=${SAVED_BY_YOU_TAB_ITEM.slug}`}
          data-qa-selector="saved_by_you_link"
        >
          {SAVED_BY_YOU_TAB_ITEM.name}
        </AnchorWithTrackEvent>
      </NavMenuListItem>
      {!userProperties.isStudent ?
        <NavMenuListItem
          key={CREATED_BY_YOU_TAB_ITEM.name}
          isHighlighted={activePageCheck(`tab=${CREATED_BY_YOU_TAB_ITEM.slug}`, activeURL)}
        >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(`tab=${CREATED_BY_YOU_TAB_ITEM.slug}`, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle)}
            eventName={`${CREATED_BY_YOU_TAB_ITEM.name}-Navigate`}
            eventProperties={{
              description: `your content drawer ${CREATED_BY_YOU_TAB_ITEM.name} link`
            }}
            href={`/my-content?tab=${CREATED_BY_YOU_TAB_ITEM.slug}`}
            data-qa-selector="created_by_you_link"
          >
            {CREATED_BY_YOU_TAB_ITEM.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>
        :
        null}
      {userProperties.isDistrictLeader || userProperties.isStudent ?
        null
        :
        <NavMenuListItem
          key={YOUR_SCHOOL_TAB_ITEM.name}
          isHighlighted={activePageCheck(`tab=${YOUR_SCHOOL_TAB_ITEM.slug}`, activeURL)}
        >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(`tab=${YOUR_SCHOOL_TAB_ITEM.slug}`, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle)}
            eventName={`${YOUR_SCHOOL_TAB_ITEM.name}-Navigate`}
            eventProperties={{
              description: `your content drawer ${YOUR_SCHOOL_TAB_ITEM.name} link`
            }}
            href={`/my-content?tab=${YOUR_SCHOOL_TAB_ITEM.slug}`}
            data-qa-selector="at_your_school_link"
          >
            {YOUR_SCHOOL_TAB_ITEM.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>}
    </NavMenuList>
  );
};

YourContentDrawer.propTypes = propTypes;
export default YourContentDrawer;
